import { css } from '@theme-ui/css';
var getCSS = function getCSS(props) {
  return function (theme) {
    var styles = css(props.sx)(theme);
    var raw = typeof props.css === 'function' ? props.css(theme) : props.css;
    return [styles, raw];
  };
};
var parseProps = function parseProps(props) {
  if (!props || !props.sx && !props.css) return props;
  var next = {};
  for (var key in props) {
    if (key === 'sx') continue;
    next[key] = props[key];
  }
  next.css = getCSS(props);
  return next;
};
export default parseProps;